






















import { Component, Vue } from "vue-property-decorator";

@Component
export default class PageNotFound extends Vue {
  get canGoBack(): boolean {
    return document.referrer.split("/")[2] === window.location.host;
  }

  back(): void {
    window.history.back();
  }

  home(): void {
    this.$router.push({ name: "home" });
  }
}
